import React, { createContext, useContext, useEffect, useState } from "react"; // Import React and hooks
import { Urls } from "./Urls"; // Import URLs from Urls file
import Axios from "./Axios"; // Import Axios instance
import { UserDetailsContext } from "./UserDetailsContext";

export const CompanyDetailsContext = createContext({});

export const CompanyDetailsProvider = ({ children }) => {
  const [companyName, setCompanyName] = useState({});
  const [userDetails] = useContext(UserDetailsContext)
  const [companyID, setCompanyID] = useState()

  useEffect(() => {
    if(userDetails && userDetails.user_details && userDetails.user_details.email){
      Axios.get(`${Urls.companyProfile}?email=${userDetails.user_details.email}`)
          .then(res => {
              if (res.data.domain_data) {
                  setCompanyName(res.data.domain_data.company_name)
                  if(res.data.domain_data.company_id){
                    setCompanyID(res.data.domain_data.company_id)
                  }
              }
          })
          .catch(err => {
              console.log(err)
          })
    }
  }, [userDetails]);

  return (
    <CompanyDetailsContext.Provider value={[companyName, companyID]}>
      {children}
    </CompanyDetailsContext.Provider>
  );
};

// Custom hook to use user details context
export function useCompany(){
  return useContext(CompanyDetailsContext)
}
